<template>
    <div class="operate-btns">
        <el-collapse v-model="activeName" accordion>
            <el-collapse-item
                v-for="(button, index) in operationBtns"
                :key="button.key"
                :name="button.key">
                <template slot="title" >
                    <div class="button-title">
                        {{button.operateName}}
                    </div>
                    <div class="form-item-option">
                        <i class="el-icon-delete" @click.stop="handleDeleteItem(index)" title="删除"></i>
                    </div>
                </template>
                <el-form size="mini"  style="height:300px;width:100%;overflow-y:auto" label-width="80px" class="button-props">
                    <el-form-item label="按钮名称">
                        <el-input placeholder="请输入内容" v-model="button.operateName"></el-input>
                    </el-form-item>
                    <el-tooltip content="驳回后，再次完成的按钮的名称" effect="light" placement="top">
                        <el-form-item label="再次完成">
                            <el-input placeholder="请输入内容" v-model="button.operateNameExt"></el-input>
                        </el-form-item>
                    </el-tooltip>
                    <el-form-item label="按钮动作">
                        <!-- 1完成 2同意 3驳回(默认到前一节点) 4驳回至发起人 5跳过当前节点 -->
                        <el-radio-group v-model="button.operateType" size="mini" class="operate-type" @change="onclick(index)">
                            <el-radio label="1" @change="handleRadioChanges">完成</el-radio>
                            <el-radio label="2" @change="handleRadioChanges">同意</el-radio>
                            <el-radio label="3" @change="handleRadioChanges">驳回</el-radio>
                            <el-radio label="6" @change="handleRadioChanges">跳转一</el-radio>
                            <el-radio label="7" @change="handleRadioChanges">跳转二</el-radio>
                            <el-radio label="8" @change="handleRadioChanges">跳转三</el-radio>
                            <el-radio label="9" @change="handleRadioChanges">驳回并删除数据</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="按钮意见">
                        <!-- 0无需填写 1选填 2必填 -->
                        <el-radio-group v-model="button.opinionType" size="mini" class="operate-type">
                            <el-radio :label="0" >无需填写</el-radio>
                            <el-radio :label="1" >选填</el-radio>
                            <el-radio :label="2" >必填</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="index==0" label="变量配置" >
                        <el-tooltip content="如果是包容网关，展开后可以进行包容网关的变量配置，否则不需要进行配置。默认收起状态。" placement="top">
                            <el-switch
                                v-model="openInclusiveGageWage"
                                active-text="展开"
                                inactive-text="收起"
                                @change="inclusiveGageWageChange"
                                style="margin-left:30px;"
                                >
                            </el-switch>
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item v-if="index==0 && openInclusiveGageWage">
                        <el-row
                            v-for="(condition, index2) in button.conditions"
                            :key="condition.key" >
                            <el-col :span="10">
                            <el-form-item label="变量名" :prop="condition.varName">
                                <el-input v-model="condition.varName"></el-input>
                            </el-form-item>
                            </el-col>
                            <el-col :span="10">
                            <el-form-item label="表达式"  :prop="condition.varExp">
                                <!-- onkeypress="this.value=this.value.replace(/[^\a-\z.]/g,'')" -->
                                <el-input   v-model="condition.varExp" />
                            </el-form-item>
                            </el-col>
                            <el-col  :span="4">
                                <el-button @click.prevent="removeCondition(condition,index)">删除</el-button>
                            </el-col>
                        </el-row>
                        <el-form-item>
                            <el-button @click="addCondition(index)">新增变量名</el-button>
                        </el-form-item>
                    </el-form-item>

                </el-form>
            </el-collapse-item>
        </el-collapse>
        <!-- <div class="button-list">
            <div class="button-item" v-for="button in operationBtns" :key="button.key">1</div>
        </div> -->
        <el-button type="text" icon="el-icon-circle-plus-outline" plain @click="handleButtonAdd">添加按钮</el-button>
    </div>
</template>
<script>
    import { getUUID } from '@/utils/grocer';
    export default {
        data () {
            return {
                openInclusiveGageWage: false,
                activeName: 1,
                btnName: ['完成', '同意', '驳回', '', '', '跳转一', '跳转二', '跳转三', '驳回']
            };
        },
        props: {
            operationBtns: {
                type: Array,
                default: () => { return []; }
            }
        },
        watch: {
            'operationBtns' (newVal, oldVal) {
                if (this.operationBtns && this.operationBtns.length > 0) { // 当没有设置按钮时，默认填充一个完成按钮事件
                } else {
                    this.handleButtonAdd();
                }
            }
        },
        created () {
            if (this.operationBtns && this.operationBtns.length > 0) { // 当没有设置按钮时，默认填充一个完成按钮事件
            } else {
                this.handleButtonAdd();
            }
        },
        methods: {
            handleButtonAdd () {
                this.operationBtns.push({
                    key: getUUID(16, 16),
                    operateName: '完成',
                    operateType: '1',
                    viewOrder: this.operationBtns.length,
                    opinionType: 0,
                    conditions: [
                        // {value: ''}
                    ]
                });
            },
            handleDeleteItem (index) {
                this.operationBtns.splice(index, 1);
            },
            handleRadioChanges (val) {
                // console.log(val);
            },
            onclick (index) {
                for (let i = 0; i < this.operationBtns.length; i++) {
                    if (index === i) {
                        this.operationBtns[index].operateName = this.btnName[this.operationBtns[index].operateType - 1];
                    }
                }
            },
            removeCondition (item, index) {
                var index2 = this.operationBtns[index].conditions.indexOf(item);
                if (index2 !== -1) {
                    this.operationBtns[index].conditions.splice(index2, 1);
                }
            },
            addCondition (index) {
                this.operationBtns[index].conditions.push({
                    value: '',
                    key: Date.now()
                });
            },
            inclusiveGageWageChange () {
                // console.log(this.openInclusiveGageWage);
            }
        }
    };
</script>


<style lang="less">
    .operate-btns {
        display: flex;
        flex-direction: column;

        .el-collapse {
            border-left: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
        }

        .button-title {
            padding: 0 0 0 10px;
            flex: 1;
        }

        .form-item-option {
            // position: absolute;
            width: 20px;
            right: 50px;
            cursor: pointer;
            display: block;
        }
        

        .button-list {
            display: flex;
            flex-direction: column;
        }
        .button-props {
            width: 600px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessEditor/components/OperateBtns.vue